import { Title } from '../../../components'
import {
    Container
} from './styles'

export default function (){
    return (
        <Container>
            <div className="row">
                <div className="col">
                    <Title>Back-Up</Title>

                    <section className="mt-2 p-3">

                        <ul>
                            <li>Scout;</li>
                            <li>Axial P.M.;</li>
                            <li>Axial P.M. C2-C3;</li>
                            <li>Axial P.M. C3-C4;</li>
                            <li>Axial P.M. C4-C5;</li>
                            <li>Axial P.M. C5-C6;</li>
                            <li>Axial P.M. C6-C7;</li>
                            <li>Axial Osso;</li>
                            <li>Axial Osso C2-C3;</li>
                            <li>Axial Osso C3-C4;</li>
                            <li>Axial Osso C4-C5;</li>
                            <li>Axial Osso C5-C6;</li>
                            <li>Axial Osso C6-C7;</li>
                            <li>Sagital P.M.;</li>
                            <li>Sagital Osso;</li>
                            <li>Coronal P.M.;</li>
                            <li>Coronal Osso;</li>
                            <li>3D VR Coluna Cervical Dir./Esq;</li>
                            <li>3D VR Coluna Cervical Sup./Inf;</li>
                            <li>Relatório de dose;</li>
                        </ul>
                    </section>
                </div>
            </div>
        </Container>
    )
}